// extracted by mini-css-extract-plugin
export var modal = "_dv-0";